import { useContext } from 'react';

import {
  DinerAccountContext,
  type DinerAccountContextInterface
} from 'reservations/dinerAccount/providers/DinerAccountProvider';

export const useDinerAccount = (): DinerAccountContextInterface => {
  const context = useContext(DinerAccountContext);
  if (context == null) {
    throw new Error('useDinerAccount must be used within DinerAccountProvider');
  }
  return context;
};
